/**
 * AnimatedSplashHost — mounts the "Stomp" splash overlay (native only) and drives it from
 * the splash store: it starts once the native splash has handed off and unmounts itself
 * after the animation completes. Web uses the static document splash, so this is a no-op there.
 */

import { Platform } from 'react-native';

import { useSplashStore } from '../../../src/shared/stores/splashStore';
import { AnimatedSplash } from '../AnimatedSplash/AnimatedSplash';

export function AnimatedSplashHost() {
  const nativeSplashHidden = useSplashStore((state) => state.nativeSplashHidden);
  const animationComplete = useSplashStore((state) => state.animationComplete);
  const markAnimationComplete = useSplashStore((state) => state.markAnimationComplete);

  if (Platform.OS === 'web' || animationComplete) {
    return null;
  }

  return <AnimatedSplash start={nativeSplashHidden} onFinish={markAnimationComplete} />;
}
